import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { createAccessPointAccessMethodOpen } from 'store/actions/accessPoints/access-methods/create/createAccessPointAccessMethodOpen';
import AccessMethodsList from './AccessMethodsList';
import Loader from 'components/loading/Loader';
import NoResults from 'components/form/styling/NoResults';
import utils from 'helpers/utils';

class AccessMethodsListContainer extends Component {
    componentDidMount() {
        const { fetchAccessMethods, id } = this.props;

        fetchAccessMethods({
            access_point_id: id,
        });
    }

    render() {
        const {
            createAccessMethodOpen,
            data,
            id,
            loading,
            resource,
        } = this.props;

        if (loading) {
            return <Loader />;
        }

        if (utils.isEmpty(data)) {
            return <NoResults label='resources.access_methods.no_results' />;
        }

        return (
            <AccessMethodsList
                createAccessMethodOpen={ createAccessMethodOpen }
                data={ data }
                id={ id }
                resource={ resource }
            />
        );
    }
}

AccessMethodsListContainer.propTypes = {
    createAccessMethodOpen: PropTypes.func,
    data: PropTypes.object,
    fetchAccessMethods: PropTypes.func,
    id: PropTypes.number.isRequired,
    loading: PropTypes.bool,
    resource: PropTypes.string.isRequired,
};

const mapStateToProps = (state, props) => {
    const { source } = props;

    return {
        data: state[source].data,
        loading: state[source].loading,
    };
};

const mapDispatchToProps = (dispatch, props) => {
    const { action } = props;

    return {
        fetchAccessMethods: (payload) => {
            dispatch(action(payload));
        },
        createAccessMethodOpen: (id) => {
            dispatch(createAccessPointAccessMethodOpen({
                id: id,
            }));
        },
    };
};

const enhance = compose(
    connect(mapStateToProps, mapDispatchToProps),
);

export default enhance(AccessMethodsListContainer);


// WEBPACK FOOTER //
// ./src/pages/accessPoints/access-methods/list/AccessMethodsListContainer.js